import React from 'react';
import { Box, Stack, InputLabel, MenuItem } from '@compass/core';
import { FormControl, Select, SelectChangeEvent } from '@mui/material';
import { useParticipantsData } from '../contexts/ParticipantsDataContext';

export const ParticipantsFilterControls = () => {
    const { filter, updateFilter, programs, schoolYears, programsLoading } = useParticipantsData();

    const handleYearChange = (event: SelectChangeEvent<number>) => {
        updateFilter({ schoolYear: Number(event.target.value) });
    };

    const handleProgramChange = (event: SelectChangeEvent<string>) => {
        const value = event.target.value;
        updateFilter({ programId: value ? Number(value) : undefined });
    };

    return (
        <Stack direction="row" spacing="sm" sx={{ mb: 2 }}>
            <FormControl size="small" sx={{ minWidth: 120 }}>
                <InputLabel id="participants-school-year-label">School Year</InputLabel>
                <Select
                    labelId="participants-school-year-label"
                    value={filter.schoolYear}
                    label="School Year"
                    onChange={handleYearChange}
                >
                    {schoolYears.map(year => (
                        <MenuItem key={year} value={year}>
                            {year}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

            <FormControl size="small" sx={{ minWidth: 120 }}>
                <InputLabel id="participants-program-label">Program</InputLabel>
                <Select
                    labelId="participants-program-label"
                    value={filter.programId?.toString() ?? ''}
                    label="Program"
                    onChange={handleProgramChange}
                    disabled={programsLoading}
                >
                    <MenuItem value="">All Programs</MenuItem>
                    {programs.map(prog => (
                        <MenuItem key={prog.id} value={prog.id}>
                            {prog.name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Stack>
    );
};